import $ from 'jquery';
import { isOperaMini } from '../_shared/helpers';

/**
 * @desc Implements auto switch between authors
 * if article has more then one author
 * NOTE: Opera Mini doesn't support setInterval normally
 * that's why we don't init it in Opera Mini
 */
export default class ArticleAuthorsSlider {
  /**
   * @param {string} itemsSelector
   * @param {string} hiddenClassName
   */
  constructor(
    itemsSelector = '.js-authors-slider-item',
    hiddenClassName = 'is-hidden',
  ) {
    this.hiddenClassName = hiddenClassName;
    this.styles = {
      top: 0,
      left: 0,
      position: 'absolute',
    };
    this.$sliderElements = $(itemsSelector);
    this.itemsCount = this.$sliderElements.length;
    this.sliderTime = 5000;
    this.current = 0;

    this.init();
  }

  init() {
    this.isInitialized = true;

    if (this.itemsCount < 2 || isOperaMini()) {
      this.isInitialized = false;

      return;
    }

    this.activateSlider();
  }

  /**
   * @desc Method activate slider hide all element except the first one and init Interval to switch elements visibility
   */
  activateSlider() {
    this.$sliderElements
      .css(this.styles)
      .addClass(this.hiddenClassName)
      .eq(this.current)
      .removeClass(this.hiddenClassName);

    setInterval(() => {
      this.changeUp();
    }, this.sliderTime);
  }

  /**
   * @desc Method hide current element and show next one
   */
  changeUp() {
    this.$sliderElements.eq(this.current).addClass(this.hiddenClassName);
    this.current += 1;

    if (this.current === this.itemsCount) {
      this.current = 0;
    }

    this.$sliderElements.eq(this.current).removeClass(this.hiddenClassName);
  }
}
